import React, { useEffect } from "react";
import { createContext, useState } from "react";
import api from "../services/api";

export const AppearanceContext = createContext({});

export function AppearanceProvider({ children }) {
  const [appearance, setappearance] = useState();
  useEffect(() => {
    (async () => {
      try {
        const { data: _appearance } = await api.get("white-label-open");
        setappearance({
          primary_color: _appearance[0]?.primary_color || "#7c309c",
          primary_color_soft: _appearance[0]?.primary_color_soft || "#f5ebf9",
          secundary_color: _appearance[0]?.secundary_color || "#53B9C7",
          secundary_color_soft: _appearance[0]?.secundary_color_soft || "#ecf7f9",
          color_error: _appearance[0]?.color_error || "hsl(0, 55%, 55%)",
          color_error_soft: _appearance[0]?.color_error_soft || "hsl(0, 100%, 97%)",
          color_success: _appearance[0]?.color_success || "hsl(93, 55%, 55%)",
          color_success_soft: _appearance[0]?.color_success_soft || "hsl(93, 100%, 97%)",
          color_warning: _appearance[0]?.color_warning || "hsl(31, 55%, 55%)",
          color_warning_soft: _appearance[0]?.color_warning_soft || "hsl(31, 100%, 97%)",
          name: _appearance[0]?.name || "Formou",
          description: _appearance[0]?.description || "Sistema de gestão para empresas de formatura",
          files: {
            logo: _appearance[0]?.file_id,
          },
          logo_url: _appearance[0]?.fileUrl,
        });
      } catch (error) {
        setappearance({
          primary_color: "#7c309c",
          primary_color_soft: "#f5ebf9",
          secundary_color: "#53B9C7",
          secundary_color_soft: "#ecf7f9",
          color_error: "hsl(0, 55%, 55%)",
          color_error_soft: "hsl(0, 100%, 97%)",
          color_success: "hsl(93, 55%, 55%)",
          color_success_soft: "hsl(93, 100%, 97%)",
          color_warning: "hsl(31, 55%, 55%)",
          color_warning_soft: "hsl(31, 100%, 97%)",
          name: "Formou",
          description: "Sistema de gestão para empresas de formatura",
          file_id: null,
          file: {
            url: "",
          },
        });
      }
    })();
  }, []);

  return (
    <AppearanceContext.Provider
      value={{
        appearance,
        setappearance,
      }}
    >
      <style>
        {`
          :root {
            --color-primary: ${appearance?.primary_color};
            --color-primary-soft: ${appearance?.primary_color_soft};
            --color-secondary: ${appearance?.secundary_color};
            --color-secondary-soft: ${appearance?.secundary_color_soft};
            --color-error: ${appearance?.color_error};
            --color-error-soft: ${appearance?.color_error_soft};
            --color-success: ${appearance?.color_success};
            --color-success-soft: ${appearance?.color_success_soft};
            --color-warning: ${appearance?.color_warning};
            --color-warning-soft: ${appearance?.color_warning_soft};
          }
        `}
      </style>
      {!!appearance && children}
    </AppearanceContext.Provider>
  );
}
